import { useMemo } from "react";
import calcSum from "@arelia-utils/helpers/calcSum";
import AgePresenter from "./AgePresenter";
import { ConnectionName } from "@arelia-types/connection";
import useRequiredConnections from "@arelia-utils/helpers/useRequiredConnections";
import { useAudience } from "../../api/streaming";
import { useAudienceArtistFilter } from "@arelia-hooks/artistAccount";

export default function AgeContainer() {
  const requiredConnectionNames = [ConnectionName.youtube, ConnectionName.spotify];
  const hasRequiredConnections = useRequiredConnections(requiredConnectionNames);
  const { data, isLoading, isError } = useAudience({ enabled: hasRequiredConnections });
  const filteredData = useAudienceArtistFilter(data);

  const audienceByAge = useMemo(() => {
    if (!filteredData) return [];
    const totalAudience = calcSum(Object.values(filteredData.age));
    return Object.entries(filteredData.age).map(([key, value]) => ({
      label: key,
      value: +(value / totalAudience * 100).toFixed(0)
    }));
  }, [filteredData]);

  return (
    <AgePresenter ages={audienceByAge} loading={isLoading} error={isError} unconnected={!hasRequiredConnections} />
  );
}
